import {
  CREDIT_SOURCE_TYPE,
  CREDIT_SOURCE_TYPE_LABEL,
} from "@portal/types/entities/credit-memo";

export const credit_source_labels: CREDIT_SOURCE_TYPE_LABEL = {
  CREDIT_MEMO: "Credit Memo",
  INVOICE_ITEM_ADJUSTMENT: "Invoice Item Adjustment",
  CREDIT_BALANCE_ADJUSTMENT: "Credit Balance Adjustment",
};

export function getCreditSourcesLabel(source?: CREDIT_SOURCE_TYPE) {
  if (!source) return;
  return credit_source_labels[source];
}
